import { NavDropdown } from "react-bootstrap";

export function XtNavDropdown(props) {
    return (<NavDropdown {...props}>
        {props.children}
    </NavDropdown>);
}
